import { FormikAccidentData } from "./formik-accident.types";
import { FormikVehicle } from "./formik-vehicle.types";

export type FormikDraftCAI = {
  accidentData: FormikAccidentData;
  vehicleA: FormikVehicle;
  vehicleB: FormikVehicle;
};

export enum FormikStep {
  VEHICLE_A = 0,
  VEHICLE_B = 1,
  ACCIDENT_DATA = 2,
  SIGNATURE_A = 3,
}
